// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1__KX","cls2":"UpsellModalRedesign-cls2_p1c UpsellModalRedesign-cls1__KX"};